import {
  type UseQueryOptions,
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { BOARD_CONFIG } from "@/config/browserBoard";
import type { ArchiveStorage } from "@/features/archive/types";
import { apiGet } from "@/shared/api";

export function getArchiveStoragePath(slug: string): string {
  return `/archive/${encodeURIComponent(slug)}/storage`;
}

function getArchiveStorageQueryOptions(
  slug: string,
  enabled: boolean,
  revision: number = 0,
): UseQueryOptions<ArchiveStorage> {
  const path = getArchiveStoragePath(slug);
  return {
    queryKey: ["archive-storage", path, revision],
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      apiGet<ArchiveStorage>(path, { boardKey: slug, signal }),
    refetchOnWindowFocus: true,
    enabled,
  } as const;
}

export function useArchiveStorage(
  enabled: boolean = true,
): UseQueryResult<ArchiveStorage> {
  return useQuery(
    getArchiveStorageQueryOptions(BOARD_CONFIG.boardKey, enabled),
  );
}

/** 総合過去ログで選択中の各板について、板別容量を同時に取得する。 */
export function useArchiveStorages(
  slugs: readonly string[],
  enabled: boolean = true,
  revision: number = 0,
): UseQueryResult<ArchiveStorage>[] {
  return useQueries({
    queries: slugs.map((slug) =>
      getArchiveStorageQueryOptions(slug, enabled, revision),
    ),
  });
}
